import React, { useState, useEffect } from "react";

import { Carousel } from "primereact/carousel";
import { Image } from "primereact/image";

export default function CarouselCircular() {
  const [images, setImages] = useState([]);

  const itemTemplate = (image) => {
    return <Image src={image} alt="Textum" width="100%" />;
  };

  useEffect(() => {
    setImages([
      "/textum_1.png",
      "/textum_2.png",
      "/textum_3.png",
      "/textum_4.png",
    ]);
  }, []);

  return (
    <div className="carousel">
      <Carousel
        value={images}
        numVisible={1}
        numScroll={1}
        circular
        autoplayInterval={5000}
        itemTemplate={itemTemplate}
      />
    </div>
  );
}
